import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export default function Breadcrumbs({ items }) {
  return (
    <nav className="text-xs uppercase tracking-wider text-[#5C5C5C] flex items-center flex-wrap gap-1" data-testid="breadcrumbs">
      {items.map((it, i) => {
        const last = i === items.length - 1;
        return (
          <span key={i} className="flex items-center gap-1">
            {it.to && !last ? (
              <Link to={it.to} className="hover:text-[#121212]" data-testid={`breadcrumb-${i}`}>{it.label}</Link>
            ) : (
              <span className="text-[#121212]" data-testid={`breadcrumb-${i}`}>{it.label}</span>
            )}
            {!last && <ChevronRight size={12} />}
          </span>
        );
      })}
    </nav>
  );
}
